import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useContext from '../../../../../hooks/useContext';
import ApiDatabase from '../../../../../server';
import Button from '../../../../button';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Modalheader from '../../../components/header';
import useModal from '../../../useModal';

const AdminModalMissionAssignationConfirmation = () => {
  const { toggle } = useModal();
  const { assignationMissionTempWorker, setModalDataReturn, updateMissionAssignment } = useContext();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    if (assignationMissionTempWorker.idTempWorker) {
      ApiDatabase.getUserById(
        { token, id_user: assignationMissionTempWorker.idTempWorker },
        (data) => {
          setUser(data);
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.log(err);
          }
        }
      );
    }
  }, [assignationMissionTempWorker]);

  const handleSubmit = () => {
    if (
      assignationMissionTempWorker.idMission &&
      assignationMissionTempWorker.idTempWorker &&
      user._id
    ) {
      // Optimistic update : mettre à jour l'UI immédiatement
      updateMissionAssignment(assignationMissionTempWorker.idMission, user, true);
      
      // Mettre à jour l'URL avec le missionId pour refléter l'état actuel
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('missionId', assignationMissionTempWorker.idMission);
      const newUrl = window.location.pathname + '?' + urlParams.toString();
      window.history.pushState({}, document.title, newUrl);
      
      // Fermer le modal immédiatement
      setModalDataReturn('mission assigned');
      toggle();
      
      // Appel API en arrière-plan
      setLoading(true);
      ApiDatabase.assignTempWorkerToMission(
        {
          token,
          idMission: assignationMissionTempWorker.idMission,
          idTempWorker: assignationMissionTempWorker.idTempWorker,
        },
        async (data) => {
          setLoading(false);
          toast.success("L'intérimaire a bien été assigné à la mission");
          // Le WebSocket mettra à jour les données avec les vraies valeurs du serveur
        },
        async (err) => {
          setLoading(false);
          if (err.name !== 'CanceledError') {
            // Rollback : annuler l'optimistic update en cas d'erreur
            updateMissionAssignment(assignationMissionTempWorker.idMission, user, false);
            toast.error(
              err.response?.data?.message ||
                err.response?.data?.error ||
                "Un problème est survenue lors de l'assignation de la mission"
            );
          }
        }
      );
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Assigner la mission
      </Modalheader>
      <ModalBody>
        Êtes-vous sûr d’attribuer la mission à {user.firstname} {user.lastname}{' '}
        ? L’intérimaire et l’entreprise seront notifiés.
      </ModalBody>
      <ModalFooter>
        {loading ? (
          <>
            <Button size={'LG'} color={'DISABLED'}>
              Annuler
            </Button>
            <Button size={'LG'} color={'DISABLED'}>
              Assignation de la mission...
            </Button>
          </>
        ) : (
          <>
            <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
              Annuler
            </Button>
            <Button 
              size={'LG'} 
              onClick={() => handleSubmit()}
              color={!user._id ? 'DISABLED' : 'PRIMARY'}
            >
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default AdminModalMissionAssignationConfirmation;
